import React, { PureComponent } from "react";
import { Redirect } from "react-router";
import * as myConstClass from "../../constant.js";
import $ from "jquery";
import { toastr } from "react-redux-toastr";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import moment from "moment";
import {
  Breadcrumb,
  BreadcrumbItem,
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Button,
  Label,
  FormGroup,
  CustomInput,
  Form,
  Input,
} from "reactstrap";
import {
  AvForm,
  AvField,
  AvGroup,
  AvInput,
  AvFeedback,
} from "availity-reactstrap-validation";
import { T, Config, TF } from "react-translator-component";
const image = `https://workzonepro.workzoneplus.com/backend/img/Work-Zone-Plus-logo.png`;
const image2 = `https://workzonepro.workzoneplus.com/backend/img/clock.png`;

// const {logout} = props.location.state;
class LogInForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      form: "1",
      showPassword: false,
      toDashboard: false,
      timeOut: 5000,
      showCloseButton: true,
      progressBar: true,
      position: "top-right",
      submitted: false,
    };
    // this.login = this.login.bind(this);
    this.onDocChangeHandler = this.onDocChangeHandler.bind(this);
    this.handleCheckChangeHourLeave =
      this.handleCheckChangeHourLeave.bind(this);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  handleCheckChangeHourLeave() {
    this.setState({
      hourchecked: !this.state.hourchecked,
    });
  }

  handleSubmit = (event, errors, values) => {
    //$('html, body').animate({ scrollTop: 0 }, 'fast');
    var i = 0;
    if (this.state.user_id == "0") {
      if (this.state.from_date == undefined) {
        $("#spanfmbox").addClass("is-invalid1");
        $("#spanfmlabel").css("color", "#dc3545");
        $("#spanfmbox").css("border-color", "#dc3545");
        $("#spanfm").show();
        i++;
        //return;
      }
      if (this.state.to_date == null) {
        $("#spantobox").addClass("is-invalid1");
        $("#spantolabel").css("color", "#dc3545");
        $("#spantobox").css("border-color", "#dc3545");
        $("#spanto").show();
        window.scrollTo(0, 2000);
        i++;
        //return;
      }
    } else {
      if (
        this.state.from_date == undefined &&
        this.state.formData.from_date == undefined
      ) {
        $("#spanfmbox").addClass("is-invalid1");
        $("#spanfmlabel").css("color", "#dc3545");
        $("#spanfmbox").css("border-color", "#dc3545");
        $("#spanfm").show();
        i++;
        //return;
      }
      if (
        this.state.to_date == null &&
        this.state.formData.to_date == undefined
      ) {
        $("#spantobox").addClass("is-invalid1");
        $("#spantolabel").css("color", "#dc3545");
        $("#spantobox").css("border-color", "#dc3545");
        $("#spanto").show();
        window.scrollTo(0, 2000);
        i++;
        //return;
      }
    }
    if (errors) {
      return;
    }

    if (i !== 0) {
      return;
    }
  };

  handleFromDateChange = (from_date) => {
    this.setState({ from_date });

    $("#spanfmbox").removeClass("is-invalid1");
    $("#spanfmlabel").css("color", "#3e4676");
    $("#spanfmbox").css("border-color", "hsl(0,0%,80%)");
    $("#spanfm").hide();
  };
  handleToDateChange = (to_date) => {
    this.setState({ to_date });
    $("#spantobox").removeClass("is-invalid1");
    $("#spantolabel").css("color", "#3e4676");
    $("#spantobox").css("border-color", "hsl(0,0%,80%)");
    $("#spanto").hide();
  };
  handleValidSubmit = () => {
    var i = 0;
    if (this.state.user_id == "0") {
      if (this.state.from_date == undefined) {
        $("#spanfmbox").addClass("is-invalid1");
        $("#spanfmlabel").css("color", "#dc3545");
        $("#spanfmbox").css("border-color", "#dc3545");
        $("#spanfm").show();
        i++;
        //return;
      }
      if (this.state.to_date == null) {
        $("#spantobox").addClass("is-invalid1");
        $("#spantolabel").css("color", "#dc3545");
        $("#spantobox").css("border-color", "#dc3545");
        $("#spanto").show();
        window.scrollTo(0, 2000);
        i++;
        //return;
      }
    } else {
      if (
        this.state.from_date == undefined &&
        this.state.formData.from_date == undefined
      ) {
        $("#spanfmbox").addClass("is-invalid1");
        $("#spanfmlabel").css("color", "#dc3545");
        $("#spanfmbox").css("border-color", "#dc3545");
        $("#spanfm").show();
        i++;
        //return;
      }
      if (
        this.state.to_date == null &&
        this.state.formData.to_date == undefined
      ) {
        $("#spantobox").addClass("is-invalid1");
        $("#spantolabel").css("color", "#dc3545");
        $("#spantobox").css("border-color", "#dc3545");
        $("#spanto").show();
        window.scrollTo(0, 2000);
        i++;
        //return;
      }
    }
    if (i !== 0) {
      return;
    }

    this.setState({ submitted: false }, () => {
      // const answer_array = this.props.location.pathname.split("/");
      // var admin_id = localStorage.getItem("uname");
      // var login_id = localStorage.getItem("login_id");
      // var login_type = localStorage.getItem("login_type");
      // var departementhead = localStorage.getItem("departementhead");
      const data = new FormData();
      data.append("attachment", this.state.file);
      data.append("formdata", JSON.stringify($("#pformm").serializeArray()));
      //  setTimeout(() => this.setState({ submitted: false }), 5000);
      fetch(
        myConstClass.SITE_URL +
          this.state.url +
          `index.php/attendance/add_leave/` +
          this.state.tenant_id +
          "/" +
          0 +
          "/" +
          0 +
          "/" +
          0 +
          "/" +
          0,
        {
          method: "POST",
          body: data,
        }
      )
        .then((response) => response.json())
        .then((response) => {
          this.setState({ submitted: false });
          if (response == 3) {
            this.state.user_id == "0"
              ? toastr.success(
                  TF("{0}", T("Success")),
                  TF("{0}", T(myConstClass.ADDMSG)),
                  this.options
                )
              : toastr.success(
                  TF("{0}", T("Success")),
                  TF("{0}", T(myConstClass.UPDATEMSG)),
                  this.options
                );
   localStorage.setItem("leave", "0");
    window.location.href = "/";
            
          } else if (response == 2) {
            toastr.error(
              TF("{0}", T("Error")),
              TF("{0} {1} {2}...!", T("Please"), T("Select"), T("Leave")),
              this.options
            );
          } else if (response == 5) {
            toastr.error(
              TF("{0}", T("Error")),
              TF(
                "{0} {1} {2} {3}...!",
                T("Please"),
                T("Select"),
                T("From"),
                T("Date")
              ),
              this.options
            );
          } else if (response == 6) {
            toastr.error(
              TF("{0}", T("Error")),
              TF(
                "{0} {1} {2} {3}...!",
                T("Please"),
                T("Select"),
                T("To"),
                T("Date")
              ),
              this.options
            );
          } else if (response == 7) {
            toastr.error(
              TF("{0}", T("Error")),
              TF("{0}...!", T("From Date should not be greater than To Date")),

              this.options
            );
          } else if (response == 88) {
            toastr.error(
              TF("{0}", T("Error")),
              TF("{0}...!", T("Check Your Leave Bank")),
              this.options
            );
          } else if (response == 99) {
            toastr.error(
              TF("{0}", T("Error")),
              TF("{0}...!", T("Please add leave templete for this employee")),
              this.options
            );
          } else if (response == 73) {
            toastr.error(
              TF("{0}", T("Error")),
              TF("{0}...!", T("Leave present at this date")),
              this.options
            );
          } else {
            toastr.error(
              TF("{0}", T("Error")),
              TF(
                "{0} {1} {2} {3}..!",
                T("Can"),
                T("not"),
                T("Add"),
                T("Leave")
              ),
              this.options
            );
          }
        })
        .catch();
    });
  };
  componentDidMount() {
    // localStorage.setItem('forget', '0');
    // window.location.href = '/';
    $(".main").css("background-image", "none");
    $(".main").css("background-size", "none");
    //alert('hii');
    // if(this.state.interval_dynamic=='2')
    // {
    //this.interval = setInterval(() => this.tick(), 30000);
    // }
  }
  onFormCancel = () => {
    localStorage.setItem("leave", "0");
    window.location.href = "/";
  };
  onFormSubmit = () => {
    this.setState({ submitted: true }, () => {
      setTimeout(() => this.setState({ submitted: false }), 5000);

      fetch(myConstClass.LOGIN_URL + `user/getEmployeeID`, {
        method: "POST",
        body: JSON.stringify($("#pform").serializeArray()),
      })
        .then((response) => response.json())
        .then((response) => {
          var code = $("#code").val();
          if (response == 2) {
            toastr.error("Error", "Please enter Employee ID..!", this.options);
          } else if (response == 3) {
            toastr.error("Error", "password Does not exists..!", this.options);
          } else if (response) {
            this.setState({ form: 0 });
            this.setState({ tenant_id: response.tenant_id });
            this.setState({ employee_id: response.id });
            this.setState({ organization_id: response.organization_id });
            this.setState({ url: response.url });
            // this.setState({ interval_dynamic: response.interval_dynamic });
            // this.setState({ form: 0 });
            // this.setState({ qrcode: response.qrimage });
            // this.setState({ title: response.title });

            fetch(
              myConstClass.SITE_URL +
                response.url +
                "index.php/user/getLeavesBalance/" +
                response.tenant_id +
                "/" +
                response.id
            )
              .then((response) => response.json())
              .then((response) => {
                this.setState({ current_bal: response });
              })
              .catch((err) => console.log(err));

            fetch(
              myConstClass.SITE_URL +
                response.url +
                "index.php/constants/getLeaveTypeDropdown/" +
                response.id
            )
              .then((response) => response.json())
              .then((response) => {
                //this.setState({leaves: response})

                if (response != "") {
                  this.setState({ leaves: response });
                } else {
                  this.setState({ leaves: "" });
                  toastr.error(
                    TF("{0}", T("Error")),
                    //"Please Add Leave Type ..!",
                    TF(
                      "{0} {1} {2} {3}..!",
                      T("Please"),
                      T("Add"),
                      T("Leave"),
                      T("Type")
                    ),
                    this.options
                  );
                }
              })
              .catch((err) => console.log(err));
            fetch(
              myConstClass.SITE_URL +
                response.url +
                "index.php/attendance/get_all_employees/" +
                response.tenant_id
            )
              .then((response) => response.json())
              .then((response) => {
                this.setState({ emp: response });
              })
              .catch((err) => console.log(err));

            fetch(
              myConstClass.SITE_URL +
                response.url +
                "index.php/organization/get_all_organizations_active/" +
                response.tenant_id
            )
              .then((response) => response.json())
              .then((response) => {
                this.setState({ org: response });
              })
              .catch((err) => console.log(err));
            // localStorage.setItem('qrscan', '0');
            // this.props.history.push({
            //   pathname : '/'+myConstClass.TENANT_PAGE_PATH+'/organizationqrcode/qrcode',

            //   state :{
            //   _id : response.qrimage,
            //   }
            //   }
            // );
            //localStorage.setItem('signup', '1');

            // toastr.success(
            //   'Success',
            //   "Password Sent Successfully on your email..!",
            //   this.options
            // )
            // window.location.href = '/';
          } else {
            toastr.error("Error", "password Does not exists..!", this.options);
          }
        })
        .catch();
    });
  };

  onDocChangeHandler(e) {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      this.setState({
        file: file,
        // imagePreviewUrl: reader.result
      });
    };
    reader.readAsDataURL(file);
  }

  render() {
    const { formData, units, submitted, current_bal, org } = this.state;
    const { emp, leaves } = this.state;
    if (this.state.toDashboard === true) {
      window.location.href = "/dashboard";
      return <Redirect to="/dashboard" />;
    }

    let balance_div;
    let bal;
    balance_div = current_bal
      ? current_bal.map((cell, i) => {
          return (
            <Row>
              <Col lg={6}>
                <label>{cell.leave_title}</label>
              </Col>

              <Col lg={3}>
                <label>{cell.current_balance}</label>
              </Col>
              <Col lg={3}>
                <label>{cell.is_negative}</label>
              </Col>
            </Row>
          );
        })
      : "";
    const start =
      this.state.checked == "1" || this.state.hourchecked == "1" ? null : (
        <AvGroup>
          <Label for="example">
            {TF("{0} {1} {2}", T("Select"), T("Start"), T("Time"))}
          </Label>
          <AvField
            type="select"
            id="from_date_time"
            value={
              formData ? formData.from_date_time : this.state.from_date_time
            }
            onChange={this.handleChange}
            name="from_date_time"
            className="mb-3"
          >
            <option value="">
              {TF("{0} {1}", T("Select"), T("Duration"))}{" "}
            </option>
            <option value="1">{TF("{0}", T("Starts in first half"))} </option>
            <option value="2">{TF("{0}", T("Starts in second half"))} </option>
          </AvField>
        </AvGroup>
      );

    const end =
      this.state.checked == "1" || this.state.hourchecked == "1" ? null : (
        <AvGroup>
          <Label for="example">
            {TF("{0} {1} {2}", T("Select"), T("End"), T("Time"))}
          </Label>
          <AvField
            type="select"
            id="end_date_time"
            value={formData ? formData.end_date_time : this.state.end_date_time}
            onChange={this.handleChange}
            name="end_date_time"
            className="mb-3"
          >
            <option value="">
              {TF("{0} {1}", T("Select"), T("Duration"))}{" "}
            </option>
            <option value="1">{TF("{0}", T("End in first half"))} </option>
            <option value="2">{TF("{0}", T("End in second half"))} </option>
          </AvField>
        </AvGroup>
      );
    return (
      <React.Fragment>
        <div className="text-center mt-4">
          {/* <h1 className="h2">Reset password</h1> */}
        </div>
        <Card>
          <CardBody>
            <div className="m-sm-4">
              <div
                style={
                  this.state.form == "1"
                    ? { display: "block" }
                    : { display: "none" }
                }
              >
                <div className="text-center">
                  {/* <img src={image2} style={{'width':'40px','height':'40px'}}></img> */}
                  <img
                    src={image2}
                    style={{ width: "40px", height: "40px;" }}
                  ></img>
                  <img
                    src={image}
                    style={{ width: "250px", height: "38px;" }}
                  ></img>
                </div>
                <br />
                <br />
                <p className="lead">Enter your Employee ID</p>
                <Form className="form" id="pform" onSubmit={this.onFormSubmit}>
                  <FormGroup>
                    <Label>Employee ID</Label>
                    <Input
                      bsSize="lg"
                      type="text"
                      id="employee_id"
                      name="employee_id"
                      placeholder="Enter your Employee ID"
                    />
                    <br />
                    {/* <Label>Password</Label>
                  <Input
                    bsSize="lg"
                    type="password"
                    name="password"
                    placeholder="Enter your Password"
                  /> */}
                  </FormGroup>
                  {/* <Link to="auth/reset"></Link> */}
                  {/* <small>
                <Link to="/auth/reset">Forgot password?</Link>
              </small> */}
                  <div className="text-center mt-3">
                    {/* <Link to="/dashboard"> 
               <Button color="primary" size="lg"  onSubmit={this.onFormSubmit}>               
               Sign in
             </Button>  
              </Link> */}
                    {/* <a href="http://localhost:3000/dashboard" > 
              <Button color="primary" size="lg"  onSubmit={this.onFormSubmit}>               
               Sign in
             </Button>        
           </a> */}
                  </div>
                  {/* <a href="<?=site_url('user_verification? email=' . $email );?> ">Click To Verifiy Email </a> */}

                  <div className="text-center mt-3">
                    {/* <a href="<?=site_url('user_verification?email=' . $email );?> ">Click To Verifiy Email </a> */}

                    {/* <Link to="auth/reset"> */}
                    <Button
                      color="primary"
                      style={{ margin: "0rem 1.50rem 0rem 0rem" }}
                      size="lg"
                      onClick={this.onFormSubmit}
                    >
                      submit
                    </Button>
                    <Button
                      color="primary"
                      size="lg"
                      onClick={this.onFormCancel}
                    >
                      Cancel
                    </Button>
                    {/* <Link to={'/' + myConstClass.TENANT_PAGE_PATH + "attendance/listing"} style={{ margin: "0rem 1.50rem 1.50rem 0rem", border: "#6f42c1 1px solid", color: "#6f42c1", padding: "0.10rem 0.90rem 0.30rem 0.90rem", textDecoration: 'none', borderRadius: '0.2rem' }}>{T("Cancel")}</Link> */}

                    {/* <Button disabled={submitted}>{
                              (submitted && 'Your form is submitted!')
                              || (!submitted && 'Submit')
                          }</Button> */}
                    {/* </Link> */}
                  </div>

                  {/* <center><img src={image3} style={{'width':'40%'}}></img><br/>    */}
                  {/* <p><a href="https://www.epenh.com" target="_blank">Developed by Epenh Co. Ltd © 2019</a></p></center> */}
                </Form>
              </div>
            </div>

            <div
              //className="text-center"
              style={
                this.state.form == "0"
                  ? { display: "block" }
                  : { display: "none" }
              }
            >
              <AvForm
                id="pformm"
                onSubmit={this.handleSubmit}
                onValidSubmit={this.handleValidSubmit}
              >
                <h4>
                  <span
                    style={{ color: "red", fontSize: "14px", float: "right" }}
                  >
                    {" "}
                    {T("All fields marked with * are required")}
                  </span>
                </h4>
                <br />
                {/* <hr /> */}
                <Row>
                  <Col lg={6}>
                    <AvField
                      type="select"
                      name="organization_id"
                      label={TF("{0} {1}", T("Select"), T("Organization"))}
                      onChange={this.ochange}
                      readOnly={"disabled"}
                      value={this.state.organization_id}
                      style={{ pointerEvents: "none" }}
                    >
                      <option>
                        {TF("{0} {1}", T("Select"), T("Organization"))}{" "}
                      </option>
                      {org
                        ? org.map((cell, i) => {
                            return (
                              <option value={cell.id}>{cell.title}</option>
                            );
                          })
                        : ""}
                    </AvField>
                  </Col>
                  <Col lg={6}>
                    <Label>
                      {TF("{0} {1}", T("Select"), T("Employee"))}
                      <span style={{ color: "red", fontSize: "15px" }}> *</span>
                    </Label>
                    {/* <AvGroup> */}

                    <AvField
                      type="select"
                      name="employee_id"
                      value={this.state.employee_id}
                      // label={TF("{0} {1}", T("Select") , T("Employee"))}
                      id="selectID"
                      onChange={this.dep_change}
                      readOnly={"disabled"}
                      style={{ pointerEvents: "none" }}
                      validate={{
                        required: {
                          value: true,
                          errorMessage: TF(
                            "{0} {1}",
                            T("Enter"),
                            T("Employee")
                          ),
                        },
                        // minLength: { value: 5, errorMessage: 'Username must be at least 5 characters' },
                        // maxLength: { value: 20, errorMessage: 'Username must not exceed 20 characters' }
                      }}
                    >
                      <option>
                        {TF("{0} {1}", T("Select"), T("Employee"))}
                      </option>
                      {emp
                        ? emp.map((cell, i) => {
                            return (
                              <option value={cell.id}>
                                {cell.first_name}
                                {cell.last_name}({cell.employee_id})
                              </option>
                            );
                          })
                        : ""}
                      {/* <AvFeedback>{TF("{0} {1}", T("Enter") , T("Employee"))}</AvFeedback> */}
                    </AvField>

                    {/* </AvGroup> */}
                  </Col>

                  <Col lg={6}>
                    {/* <AvGroup> */}
                    <Label for="example">
                      {TF("{0} {1}", T("Select"), T("Leave"))}{" "}
                    </Label>
                    <span style={{ color: "red", fontSize: "15px" }}> *</span>
                    <AvField
                      type="select"
                      id="leave_type_id"
                      value={
                        formData
                          ? formData.leave_type_id
                          : this.state.leave_type_id
                      }
                      name="leave_type_id"
                      // className="mb-3"
                      required
                    >
                      <option disabled={true} value="">
                        {T("Select")} {T("Leave")}
                      </option>
                      {leaves
                        ? leaves.map((cell, i) => {
                            return (
                              <option value={cell.leave_type_id}>
                                {cell.leave_type}
                              </option>
                            );
                          })
                        : ""}
                      {/* <AvFeedback>Enter Leave</AvFeedback> */}
                    </AvField>

                    {/* </AvGroup> */}
                  </Col>
                  <Col lg={6}>
                    <AvGroup>
                      <Label for="example">
                        {TF("{0} ", T("Reason"))}{" "}
                        <span style={{ color: "red", fontSize: "15px" }}>
                          {" "}
                          *
                        </span>
                      </Label>
                      <AvInput
                        name="reason"
                        id="example"
                        // placeholder={'Reason'}
                        required
                        value={formData ? formData.reason : ""}
                      />
                      <AvFeedback>
                        {TF("{0} {1}", T("Enter"), T("Reason"))}{" "}
                      </AvFeedback>
                    </AvGroup>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    {/* <AvGroup> */}
                    <Label id="spanfmlabel">
                      {TF("{0} {1} ({2})", T("From"), T("Date"), "DD-MM-YYYY")}
                      <span style={{ color: "red", fontSize: "15px" }}> *</span>
                    </Label>{" "}
                    <br />
                    <DatePicker
                      name="from_date"
                      placeholderText="Date"
                      selected={this.state.from_date} // should be a Date object
                      onChange={this.handleFromDateChange}
                      dateFormat="dd-MM-yyyy"
                      autoComplete="off"
                      className="form-control"
                      id="spanfmbox"
                    />
                    <span
                      id="spanfm"
                      style={{ color: "red" }}
                      //style={this.state.showGalleryPlayButton}
                      style={{ display: "none" }}
                      class="invalid-feedback11"
                    >
                      {TF("{0} {1} {2}", "Enter", T("From"), T("Date"))}
                    </span>
                    {/* </AvGroup> */}
                  </Col>
                  <Col lg={6}>
                    {/* <AvGroup> */}
                    <Label id="spantolabel">
                      {TF("{0} {1} ({2})", T("To"), T("Date"), "DD-MM-YYYY")}
                      <span style={{ color: "red", fontSize: "15px" }}> *</span>
                    </Label>{" "}
                    <br />
                    <DatePicker
                      id="spantobox"
                      name="to_date"
                      placeholderText={TF("{0}", T("Date"))}
                      selected={this.state.to_date} // should be a Date object
                      onChange={this.handleToDateChange}
                      dateFormat="dd-MM-yyyy"
                      autoComplete="off"
                       className="form-control"
                    />
                    <span
                      id="spanto"
                      style={{ color: "red" }}
                      //style={this.state.showGalleryPlayButton}
                      style={{ display: "none" }}
                      class="invalid-feedback11"
                    >
                      {TF("{0} {1} {2}", T("Enter"), T("To"), T("Date"))}
                    </span>
                    {/* </AvGroup> */}
                  </Col>
                </Row>
                <br />

                <Col lg={6} style={{ zIndex: "0" }}>
                  <CustomInput
                    type="checkbox"
                    name="full_day_leave"
                    id="exampleCustomCheckbox"
                    label={TF("{0} ", T("Full Day Leave"))}
                    disabled={this.state.fullapply}
                    className="mb-2"
                    checked={this.state.checked}
                    onChange={this.handleCheckChange}
                  />
                </Col>

                <Row>
                  <Col lg={6}> {start} </Col>
                  <Col lg={6}>{end} </Col>
                </Row>

                <Row>
                  <Col lg={6} style={{ zIndex: "0" }}>
                    <CustomInput
                      type="checkbox"
                      name="hourly_basis_leave"
                      id="exampleCustomCheckbox1"
                      label={TF("{0} ", T("Hourly Basis"))}
                      disabled={this.state.hourapply}
                      className="mb-2"
                      checked={this.state.hourchecked}
                      onChange={this.handleCheckChangeHourLeave}
                    />
                  </Col>

                  <Col
                    lg={6}
                    style={
                      this.state.hourchecked == true
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    <AvGroup>
                      <Label for="example">{TF("{0}", T("Status"))}</Label>

                      <AvField
                        type="select"
                        id="status"
                        value={
                          formData ? formData.hour_leave : this.state.hour_leave
                        }
                        // onChange={this.handleChange}
                        name="hour_leave"
                        className="mb-3"
                      >
                        <option value="0.5">0.5</option>
                        <option value="1">1.0</option>
                        <option value="1.5">1.5</option>

                        <option value="2">2.0</option>
                        <option value="2.5">2.5</option>
                        <option value="3">3.0</option>

                        <option value="3.5">3.5</option>
                        <option value="4">4.0</option>
                        <option value="4.5">4.5</option>

                        <option value="5">5.0</option>
                        <option value="5.5">5.5</option>
                        <option value="6">6.0</option>

                        <option value="6.5">6.5</option>
                        <option value="7">7.0</option>
                        <option value="7.5">7.5</option>

                        <option value="8">8.0</option>
                        <option value="8.5">8.5</option>
                        <option value="9">9.0</option>

                        <option value="9.5">9.5</option>
                        <option value="10">10.0</option>
                        <option value="10.5">10.5</option>

                        <option value="11">11.0</option>
                        <option value="11.5">11.5</option>
                        <option value="12">12.0</option>
                      </AvField>
                    </AvGroup>
                  </Col>
                </Row>
                <Row>
                  {/* {login_type != "emp" ||
                  (login_type == "emp" && departementhead != "0") ? ( */}
                  <Col lg={6}>
                    <AvGroup>
                      <Label for="example">{TF("{0}", T("Status"))}</Label>

                      <AvField
                        type="select"
                        id="status"
                        //   value={
                        //     formData
                        //       ? formData.approve_hr_status
                        //       : this.state.status
                        //   }
                        onChange={this.handleChange}
                        name="status"
                        className="mb-3"
                      >
                        <option value="1">{TF("{0}", T("Pending"))}</option>
                        {/* <option value="2">{TF("{0}", T("Approved"))}</option>
                        <option value="3">{TF("{0}", T("Rejected"))}</option> */}
                      </AvField>
                    </AvGroup>
                  </Col>
                  {/* ) : (
                    ""
                  )} */}
                </Row>
                <Row>
                  <Col lg={6}>
                    {/* <AvGroup> */}
                    <Label for="example">
                      {" "}
                      {TF("{0} {1}", T("Upload"), T("Attachment"))}
                    </Label>{" "}
                    <br />
                    <input
                      type="file"
                      id="file1"
                      name="attachment"
                      onChange={(e) => this.onDocChangeHandler(e)}
                    />
                    {/* <small>('txt','pdf','docs')</small> */}
                    {/* </AvGroup>
                     */}
                  </Col>
                </Row>

                {/* <Col lg={6}>{c_file}</Col> */}

                <Row>
                  <Col lg={6}>
                    <Label for="example">
                      {" "}
                      {TF("{0} {1}", T("Leave"), T("Balance"))}{" "}
                    </Label>
                    <Row>
                      <Col lg={6}>
                        <h6> {TF("{0} {1}", T("Leave"), T("Type"))} </h6>
                      </Col>
                      <Col lg={3}>
                        <h6> {TF("{0}", T("Balance"))}</h6>
                      </Col>
                      <Col lg={3}>
                        <h6>
                          {" "}
                          {TF(
                            "{0} {1} {2}",
                            T("Allowed"),
                            T("Negative"),
                            T("Balance")
                          )}{" "}
                        </h6>
                      </Col>
                    </Row>
                    {balance_div}
                  </Col>
                  {/* <Col lg={6}>
                    <h5 for="example">{formData.Approved}</h5>
                    <h5 for="example">{formData.Approvedh}</h5>
                  </Col> */}
                </Row>

                <br />
                <br />
                <FormGroup>
                  {/* <Link
                    to={
                      "/" +
                      myConstClass.TENANT_PAGE_PATH +
                      "shiftsleaves/listing"
                    }
                    style={{
                      margin: "0rem 1.50rem 1.50rem 0rem",
                      border: "#6f42c1 1px solid",
                      color: "#6f42c1",
                      padding: "0.10rem 0.90rem 0.30rem 0.90rem",
                      textDecoration: "none",
                      borderRadius: "0.2rem",
                    }}
                  >
                    {T("Cancel")}
                  </Link> */}
                  {this.state.user_id != "0" ? (
                    <Button disabled={submitted}>
                      {(submitted &&
                        TF(
                          "{0} {1} {2} {3}!",
                          T("Your"),
                          T("form"),
                          T("is"),
                          T("submitted")
                        )) ||
                        (!submitted && T(T("Update")))}
                    </Button>
                  ) : (
                    <Button disabled={submitted}>
                      {(submitted &&
                        TF(
                          "{0} {1} {2} {3}!",
                          T("Your"),
                          T("form"),
                          T("is"),
                          T("submitted")
                        )) ||
                        (!submitted && T(T("Add")))}
                    </Button>
                  )}
                </FormGroup>
              </AvForm>

              <Button color="primary" size="lg" onClick={this.onFormCancel}>
                Go to Login
              </Button>
            </div>
          </CardBody>
        </Card>
        {/* <center><img src={image3} style={{'width':'35%'}}></img><br/>   
       <p><a href="https://www.epenh.com" target="_blank">Developed by Epenh Co. Ltd © 2019</a></p></center> */}
      </React.Fragment>
    );
  }
}

export default LogInForm;


